import {COMP_TYPES, DATA_TYPES} from '../../constants/constants'
import {SemanticTypes} from '../mobileAlgo/preprocess/conversionDataBuilders'
import type {ResponsiveSemanticType} from './types'

export const SECTION_COMP_TYPES = new Set([
    COMP_TYPES.FOOTER_SECTION,
    COMP_TYPES.RESPONSIVE_SECTION,
    COMP_TYPES.HEADER_SECTION
])

export const SECTION_SEMANTIC_TYPES: Set<ResponsiveSemanticType> = new Set([
    SemanticTypes.SECTION,
    SemanticTypes.HEADER_SECTION,
    'FOOTER_SECTION'
])

export const DEFAULT_NAMESPACES = [DATA_TYPES.layout, DATA_TYPES.theme, DATA_TYPES.data] as const
